function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.438 3.24a.63.63 0 0 0-.876 0L1.155 7.938a.6.6 0 0 0 .876.822L6 4.527 9.969 8.76a.6.6 0 0 0 .876-.822L6.438 3.24z",
  fill: "#000",
  fillRule: "nonzero"
});
const SvgUpArrow = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUpArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/up-arrow.20459740.svg";
export { ForwardRef as ReactComponent };